var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AfterContentChecked, ChangeDetectorRef, OnInit, ViewRef, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../common/components/base.component';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { HubApiService } from '../../../services/hub.api.service';
import { ConfirmModalActions, ConfirmModalData } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { ModalService } from '../../../common/services/modal.service';
import { ImageService } from '../../../services/image.service';
import { HubCustomBtn } from '../../../models/hub/hub.custom.btn';
import { CustomBtnStore } from '../../../stores/hub.calendar.store';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { ShowPromptModalComponent } from '../show.prompt.modal/show.prompt.modal.component';
import { PromptModalData, ShowPromptModalActions } from '../show.prompt.modal/show.prompt.modal.provider';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { HubPlace } from '../../../models/hub/hub.place';
import { EditPlaceModalComponent } from '../edit.place.modal/edit.place.modal.component';
import { EditPlaceModalActions } from '../edit.place.modal/edit.place.modal.provider';
var HubSimilarPlaceCalendarComponent = /** @class */ (function (_super) {
    __extends(HubSimilarPlaceCalendarComponent, _super);
    function HubSimilarPlaceCalendarComponent(router, activatedRoute, hubApiService, modalService, imageService, changeDetector, customBtnStore) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.hubApiService = hubApiService;
        _this.modalService = modalService;
        _this.imageService = imageService;
        _this.changeDetector = changeDetector;
        _this.customBtnStore = customBtnStore;
        _this.isNoContent = false;
        _this.isNoContentFor2ParamSimilarity = false;
        _this.isNoContentForMultiDatesEvents = false;
        _this.isOperating = false;
        _this.group = -1;
        _this.hasMoreGroups = true;
        _this.groupSize = 500;
        _this.allPlaceCount = 0;
        _this.customBtns = new HubCustomBtn();
        return _this;
    }
    HubSimilarPlaceCalendarComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.customBtnStore.customBtnCommand.takeUntil(this.isDestroyed).subscribe(function (btns) {
            _this.customBtns = btns || new HubCustomBtn();
        });
        // this.getSimilarPlaces();
    };
    HubSimilarPlaceCalendarComponent.prototype.getSimilarPlaces = function (event) {
        var _this = this;
        this.group += 1;
        this.group === 0 && this.showSpinner();
        this.hubApiService
            .getSimilarPlaces(this.hubName, this.group)
            .finally(event && event.complete)
            .subscribe(function (data) {
            console.log(data);
            _this.hasMoreGroups = data.hasMoreGroups;
            _this.groupSize = data.groupSize;
            _this.allPlaceCount = data.allPlaceCount;
            if (_this.group === 0) {
                _this.similarPlaces = data.similarPlaces;
            }
            else {
                _this.similarPlaces = _this.similarPlaces.concat(data.similarPlaces);
            }
            // this.isNoContent = !this.similarPlaces || !this.similarEventsByExactSame.length;
            // this.isNoContentForMultiDatesEvents = !this.similarMultiDatesEvents || !this.similarMultiDatesEvents.length;
            _this.hideSpinner();
        });
    };
    HubSimilarPlaceCalendarComponent.prototype.ngAfterContentChecked = function () {
        this.changeDetector.detectChanges();
    };
    HubSimilarPlaceCalendarComponent.prototype.getCount = function (type) {
        if (!type || !type.length)
            return 0;
        var count = 0;
        type.forEach(function (x) {
            count += x.group.length;
        });
        return count;
    };
    HubSimilarPlaceCalendarComponent.prototype.isSimilarField = function (field, placeId, conditions) {
        var condition = conditions.find(function (x) { return x.field === field; });
        if (!condition)
            return false;
        return condition.places.indexOf(placeId) >= 0;
    };
    HubSimilarPlaceCalendarComponent.prototype.approve = function (place) {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .approvePlace(this.hubName, place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            place.isApproved = true;
        });
    };
    HubSimilarPlaceCalendarComponent.prototype.unApprove = function (place) {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .unApprovePlace(this.hubName, place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            place.isApproved = false;
        });
    };
    HubSimilarPlaceCalendarComponent.prototype.showEditModal = function (place) {
        var _this = this;
        var actions = {
            confirm: function ($event, e, image) {
                _this.getSimilarPlaces();
            },
        };
        this.hubApiService.getPlacesByPlaceIds(this.hubName, [place._id]).subscribe(function (data) {
            console.log(data);
            var p = data[0];
            // reorganize address object for backend
            p.address = {
                address: p.address.toString(),
                lat: p.lat,
                lng: p.lng,
                address_components: p.address_components,
            };
            _this.modalService.show({
                component: EditPlaceModalComponent,
                providers: [
                    { provide: EditPlaceModalActions, useValue: actions },
                    { provide: HubPlace, useValue: p },
                ],
                panelClass: 'width-modal-2',
            });
        });
    };
    HubSimilarPlaceCalendarComponent.prototype.block = function (place) {
        var _this = this;
        var actions = {
            confirm: function ($event) {
                _this.hubApiService
                    .blockPlace(_this.hubName, place._id)
                    .finally($event.complete)
                    .subscribe(function () {
                    _this.getSimilarPlaces();
                    var doNotShowModal = localStorage.getItem(localStorageKeys.doNotShowRemoveSuccessfullyModal);
                    if (!doNotShowModal) {
                        _this.showRmoveSuccessModal();
                    }
                });
            },
            cancel: function () {
                _this.isOperating = false;
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this place?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    /**
     * remove the delete event button for pulled events, as some clients are confused that if they delete an event, it will be added in the next pull
     * */
    HubSimilarPlaceCalendarComponent.prototype.deletePermanently = function (event) {
        var _this = this;
        var actions = {
            confirm: function ($event) {
                _this.hubApiService
                    .deleteEvent(_this.hubName, event._id)
                    .finally($event.complete)
                    .subscribe(function () {
                    _this.getSimilarPlaces();
                });
            },
            cancel: function () {
                _this.isOperating = false;
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to delete this event permanently, this operation cannot be reverted?',
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    HubSimilarPlaceCalendarComponent.prototype.isInCustomBtn = function (event, btn) {
        if (btn) {
            return btn.events.any(function (x) { return x === event._id; });
        }
        else {
            var isIn = false;
            if (this.customBtns.events) {
                for (var _i = 0, _a = this.customBtns.events; _i < _a.length; _i++) {
                    var x = _a[_i];
                    if (x.events.any(function (x) { return x === event._id; })) {
                        isIn = true;
                        break;
                    }
                }
            }
            return isIn;
        }
    };
    HubSimilarPlaceCalendarComponent.prototype.addOrRemoveToCustomBtn = function (event, btn, index) {
        var _this = this;
        if (!this.isInCustomBtn(event, btn)) {
            this.hubApiService.addEventToCustomBtn(this.hubName, event._id, index).subscribe(function (customEvents) {
                _this.customBtns.events = customEvents;
            });
        }
        else {
            this.hubApiService.removeEventFromCustomBtn(this.hubName, event._id, index).subscribe(function (customEvents) {
                _this.customBtns.events = customEvents;
            });
        }
    };
    HubSimilarPlaceCalendarComponent.prototype.gotoTours = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.tours, {
                            hubName: this.hubName,
                        }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HubSimilarPlaceCalendarComponent.prototype.showSpinner = function () {
        this.isLoading = true;
        this.spinner.show();
    };
    HubSimilarPlaceCalendarComponent.prototype.hideSpinner = function () {
        var _this = this;
        setTimeout(function () {
            _this.isLoading = false;
            _this.spinner.hide();
        });
    };
    HubSimilarPlaceCalendarComponent.prototype.showRmoveSuccessModal = function () {
        this.modalService.show({
            component: ShowPromptModalComponent,
            providers: [
                { provide: ShowPromptModalActions, useValue: null },
                {
                    provide: PromptModalData,
                    useValue: new PromptModalData('Remove successfully', null, [
                        'The selected item has been successfully removed from the dashboard.',
                        'You can restore this item from the Removed List at any time.',
                        'While in the Removed List, this item cannot be pulled again.',
                    ]),
                },
            ],
            panelClass: 'width-modal-2',
        });
    };
    return HubSimilarPlaceCalendarComponent;
}(BaseComponent));
export { HubSimilarPlaceCalendarComponent };
var SimilarPlaceCondition = /** @class */ (function () {
    function SimilarPlaceCondition() {
    }
    return SimilarPlaceCondition;
}());
export { SimilarPlaceCondition };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/similar.place.calendar/hub.similar.place.calendar.component.ts.pre-build-optimizer.js